import { isFromLenovo } from './ifAigcVersion.js'
import { getBrowerType } from '@/utils/system/systemUtils'
import Cookies from 'js-cookie'

/** 修改前 */
// import Cookies from 'js-cookie'
// export const handleLinkRedirection = (linkUrl) => {
//   if (Cookies.get('from') && Cookies.get('from') === 'lenovo') {
//     window.location.href = linkUrl
//   } else {
//     window.open(linkUrl, '_blank')
//   }
// }

/** ** 修改后 ***/
// 链接跳转处理函数
export const handleLinkRedirection = (linkUrl) => {
  // 检查linkUrl是否为有效的URL
  if (!linkUrl || typeof linkUrl !== 'string' || linkUrl.trim() === '') {
    console.warn('Invalid link URL provided.')
    return
  }
  const source = Cookies.get('source') ? Number(Cookies.get('source')) : 1
  if (source === 198) linkUrl = linkUrl.includes('?') ? (linkUrl + '&source=198') : (linkUrl + '?source=198')
  // 根据Cookie值决定跳转方式
  if (isFromLenovo()) {
    window.location.href = linkUrl // 当前窗口跳转
  } else {
    // if (!getBrowser().isCefBrowser) window.open(linkUrl, '_blank') // 新窗口打开
    // alert('zyc--' + getBrowerType() + '---' + getBrowser().isCefBrowser)
    if (!((getBrowerType() === 'pc' || getBrowerType() === 'pcWeb') && !getBrowser().isCefBrowser)) window.open(linkUrl, '_blank') // 新窗口打开
  }
}

export function getBrowser () {
  const curBrowser = {
    isSafariBrowser: false,
    isCefBrowser: false,
    isAndroidBrowser: false
  }
  const userAgent = navigator.userAgent || window.opera
  const isCefBrowser = (/(OpenHarmony|OHOS)/i.test(userAgent)) // Chromium Embedded Framework 是一个浏览器简称CEF
  curBrowser.isCefBrowser = isCefBrowser
  curBrowser.isSafariBrowser = /(CWKWebEngine)/i.test(userAgent) // 悟空图像iPad版
  curBrowser.isAndroidBrowser = /(CAndroidWebEngine)/i.test(userAgent)
  return curBrowser
}
